import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function CreateArticle(
    clientUuid,
    articleName,
    unitOfMeasure,
    catalogNumber,
    articleCode,
    additionalName,
    unitQuantity,
    taxRate
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/article?clientUuid=' + clientUuid, {
            method: 'post',
            headers: { 
                'Authorization' : unHashedJwt.data                 
            },
            data: {
                "articleName": articleName.trim(),
                "unitOfMeasure": unitOfMeasure.trim(),
                "catalogNumber": catalogNumber.trim(),
                "articleCode": articleCode.trim(),
                "additionalName": additionalName.trim(),
                "unitQuantity": unitQuantity.trim(),
                "taxRate": taxRate.trim()
            }      
        }).then(res => res.data)
        .catch(error => error.response.data),
        "Admin"
        );
}